import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const RouteVariant = ({
  component,
  auth_redirect='/login',
  ...rest,
}) => {
  const { session } = rest;
  if(session.isAuthenticated === true) {
    const Component = component;
    return <Component {...rest} />;
  }

  return <Redirect to={{ pathname: auth_redirect }} />;
};



// WEBPACK FOOTER //
// ./scripts/routers/RouteVariant.jsx